<div id="header">

    <div id="logo-div" [class]="logoClass" (click)="onNavigateHome()" style="cursor: pointer;">
        <img src="../../assets/images/myappicon-white.png" class="icon">
    </div>

    <div class="title-and-menu" *ngIf="!isMobileFormFactor">
        <div class="title" (click)="onNavigateHome()" style="cursor: pointer;">My Media Center</div>
        <div class="right-side">
            <p-button *ngIf="fullOrganization?.IsDocumentCenterEnabled" [outlined]="true" [label]="orgManager.viewMode === ViewMode.Album ? 'View Documents' : 'View Photos'"
                      (click)="onToggleViewMode()"></p-button>
            <p-button [outlined]="true" label="Sign Out" icon="pi pi-lock" (click)="onSignOut()"></p-button>
        </div>
    </div>

</div>
